import script from "./menuList.vue?vue&type=script&setup=true&lang=js"
export * from "./menuList.vue?vue&type=script&setup=true&lang=js"

import "./menuList.vue?vue&type=style&index=0&id=0d4394da&scoped=true&lang=css"

import exportComponent from "/var/www/html/koboeat/test/customer_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d4394da"]])

export default __exports__